import { FC } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { STYLE_VARS } from '../../../constants/style-vars';

interface ContactItemProps {
  icon: any;
  title: string;
  content: string;
}

const ContactItem: FC<ContactItemProps> = ({ icon, title, content }) => {
  return (
    <View>
      <View style={{ width: '60%', flexDirection: 'row', marginBottom: 12 }}>
        <Image source={icon} style={styles.icon} />
        <View>
          <Text style={styles.titleText}>{title}</Text>
          <Text style={styles.contentText}>{content}</Text>
        </View>
      </View>
    </View>
  );
};

export default ContactItem;

const styles = StyleSheet.create({
  icon: {
    width: 16,
    height: 16,
    marginRight: 5,
    tintColor: STYLE_VARS.primaryColor,
  },
  titleText: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 15,
    fontWeight: '500',
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  contentText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 13,
    fontWeight: '500',
    color: COLORS.GREEN,
    textTransform: 'uppercase',
  },
});
